module.exports = __webpack_public_path__ + "img/vip-wallet.ce5cd595.png";